var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "750" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { attrs: { color: "#7e5ec2" } },
            [
              _c("span", { staticClass: "material-symbols-outlined" }),
              _vm._v(" "),
              _c("p", { staticClass: "tituloCard" }, [
                _vm._v("Aprobar reprogramación")
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h4", { staticClass: "texto" }, [
                              _c("strong", { staticClass: "titulo" }, [
                                _vm._v("Número:")
                              ]),
                              _vm._v(
                                "\n                " +
                                  _vm._s(this.form.numero) +
                                  "\n              "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h4", { staticClass: "texto" }, [
                              _c("strong", { staticClass: "titulo" }, [
                                _vm._v("Nombre:")
                              ]),
                              _vm._v(
                                "\n                " +
                                  _vm._s(this.form.nombres) +
                                  "\n                "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h4", { staticClass: "subtitulo2" }, [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.subtitulo_detalle))
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass: "elevation-1",
                                attrs: {
                                  items: _vm.lista_papeleta,
                                  "hide-actions": "",
                                  headers: _vm.headers
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "items",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              _vm._s(props.item.fecha_desde)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              _vm._s(props.item.fecha_hasta)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              _vm._s(props.item.total_dias)
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.lista_reprogramaciones.length > 0 &&
                      (_vm.form.tipo == "FR" || _vm.form.tipo == "R")
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h4", [
                              _c("strong", [
                                _vm._v("Detalle de reprogramación de vacación")
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _vm.lista_reprogramaciones.length > 0 &&
                              (_vm.form.tipo == "FR" || _vm.form.tipo == "R")
                                ? _c("v-data-table", {
                                    staticClass: "elevation-1",
                                    attrs: {
                                      items: _vm.lista_reprogramaciones,
                                      "hide-actions": "",
                                      headers: _vm.headers_reprogramaciones
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(props.item.secuencia)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.item.fecha_desde
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.item.fecha_hasta
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.item.total_dias
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(props.item.estado)
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2653992357
                                    )
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("h4", { staticClass: "subtitulo2" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.subtitulo_seguimiento))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass: "elevation-1",
                                attrs: {
                                  items: _vm.lista_detalle,
                                  "hide-actions": "",
                                  headers: _vm.headers2
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "items",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  props.item.fecha_registro
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [_vm._v(_vm._s(props.item.estado))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [_vm._v(_vm._s(props.item.usuario))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [_vm._v(_vm._s(props.item.jefe))]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n        "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "rgba(14, 187, 178, 0.35)" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.solicitarUsoVacacion()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("done")]),
                      _vm._v("\n          Aprobar\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3f77b0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3f77b0c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/dialogs/AprobarReprogramacionRRHH.vue
// module id = null
// module chunks = 